export function namespaces()
{
    return {
        wikibase: 'http://wikiba.se/ontology#',
        wd: 'http://www.wikidata.org/entity/',
        wdt: 'http://www.wikidata.org/prop/direct/',
        wdtn: 'http://www.wikidata.org/prop/direct-normalized/',
        wds: 'http://www.wikidata.org/entity/statement/',
        p: 'http://www.wikidata.org/prop/',
        wdref: 'http://www.wikidata.org/reference/',
        wdv: 'http://www.wikidata.org/value/',
        ps: 'http://www.wikidata.org/prop/statement/',
        psv: 'http://www.wikidata.org/prop/statement/value/',
        psn: 'http://www.wikidata.org/prop/statement/value-normalized/',
        pq: 'http://www.wikidata.org/prop/qualifier/',
        pqv: 'http://www.wikidata.org/prop/qualifier/value/',
        pqn: 'http://www.wikidata.org/prop/qualifier/value-normalized/',
        pr: 'http://www.wikidata.org/prop/reference/',
        prv: 'http://www.wikidata.org/prop/reference/value/',
        prn: 'http://www.wikidata.org/prop/reference/value-normalized/',
        wdno: 'http://www.wikidata.org/prop/novalue/',
        wdata: 'http://www.wikidata.org/wiki/Special:EntityData/',
        rdfs: 'http://www.w3.org/2000/01/rdf-schema#',
        rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
        owl: 'http://www.w3.org/2002/07/owl#',
        skos: 'http://www.w3.org/2004/02/skos/core#',
        xsd: 'http://www.w3.org/2001/XMLSchema#',
        prov: 'http://www.w3.org/ns/prov#',
        ontolex: 'http://www.w3.org/ns/lemon/ontolex#',
        schema: 'http://schema.org/',
        geo: 'http://www.opengis.net/ont/geosparql#',
        geof: 'http://www.opengis.net/def/geosparql/function/',
        dct: 'http://purl.org/dc/terms/',
        bd: 'http://www.bigdata.com/rdf#',
        bds: 'http://www.bigdata.com/rdf/search#',
        gas: 'http://www.bigdata.com/rdf/gas#',
        hint: 'http://www.bigdata.com/queryHints#',
    };
}

export function shortenUri(uri)
{
    let ret = uri;
    let ns = namespaces();

    Object.keys(ns).every((k) => {
        let full = ns[k];

        if (uri.startsWith(full)) {
            ret = uri.replace(full, k + ':');
            return false;
        }

        return true;
    });

    return ret;
}

export function valueType(data)
{
    if (data.type == 'uri') {
        let commonsPrefixes = [
            'http://commons.wikimedia.org/wiki/special:filepath/',
            'https://commons.wikimedia.org/wiki/special:filepath/',
        ];

        for (let i = 0; i < commonsPrefixes.length; i++) {
            if (data.value.toLowerCase().startsWith(commonsPrefixes[i])) {
                return 'image';
            }
        }

        return 'uri';
    }
    else if (data.type == 'literal') {
        if (data.datatype) {
            return 'coordinates';
        }
        else if (data['xml:lang']) {
            return 'label';
        }
    }

    return data.type;
}

export function randomString(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var cLen = characters.length;

    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * cLen));
    }

    return result;
}

export function formatCell(data)
{
    let ret = null;

    if (data.type == 'uri') {
        let label = decodeURI(data.value);
        label = shortenUri(label);
        ret = '<a target="_blank" href="' +  data.value + '">' + label + '</a>';
    }
    else if (data.type == 'literal') {
        if (data.datatype) {
            if (data.datatype == 'http://www.opengis.net/ont/geosparql#wktLiteral') {
                if (data.value.startsWith('Point')) {
                    let coords = data.value.match(/Point\(([\-\.0-9]*) ([\-\.0-9]*)\)/);
                    ret = data.value + ' <a target="_blank" class="tomap" href="https://www.openstreetmap.org/#map=17/' + coords[2] + '/' + coords[1] + '"><i class="bi bi-globe"></i></a>';
                }
            }
        }
        else if (data['xml:lang']) {
            ret = data.value + ' <span class="lang">@' + data['xml:lang'] + '</span>';
        }
    }

    if (ret == null) {
        ret = data.value;
    }

    return ret;
}
